module.exports = __webpack_public_path__ + "static/media/penguin_boofi_demonlord.dfc69445.jpg";